export const MAIN_CLASS_NAME = 'folder-items';
export const BUTTON_CLASS_NAME = `${MAIN_CLASS_NAME}__button`;
export const OVERLAY_CLASS_NAME = `${MAIN_CLASS_NAME}__overlay`;
export const SCROLL_CLASS_NAME = `${OVERLAY_CLASS_NAME}__scroll`;

export const TOOLTIP_MOUSE_DELAY = 0.5;
